// schema/nodes/text.ts
var TEXT_SCHEMA = () => ({
  group: "inline",
  toDOM: (node) => ["span", node.text]
});
var TEXT_KEY = "text";
var TEXT = {
  [TEXT_KEY]: TEXT_SCHEMA
};
export {
  TEXT,
  TEXT_KEY,
  TEXT_SCHEMA
};
